import { gql } from '@apollo/client'

export const ON_MEDIA_CHANGES = gql`
  subscription onMediaChanges($tvId: Int) {
    onMediaChanges(tvId: $tvId) {
      TVsConcerned
    }
  }
`